import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-page-title" }
const _hoisted_2 = { class: "d-lg-flex container px-0 filter-with-actions-wrapper" }
const _hoisted_3 = { class: "actions-btn-bar order-lg-1 mb-lg-0 px-2 px-md-0" }
const _hoisted_4 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_5 = { class: "index-statistics-filter-template-wrapper" }
const _hoisted_6 = { class: "filter-dates-title px-3 px-md-0" }
const _hoisted_7 = { class: "d-flex px-3 px-md-0 index-statistics-filter-template" }
const _hoisted_8 = { class: "d-flex flex-column flex-md-row align-items-center" }
const _hoisted_9 = { class: "search-button-wrapper mx-1" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_11 = { class: "show-all-clear-filter align-items-lg-center mx-2 mt-2 mt-md-0 text-nowrap" }
const _hoisted_12 = { class: "dashboard container container-flex mb-" }
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = { class: "col-md-3 pb-2 px-2 px-md-4" }
const _hoisted_15 = { class: "block blue" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "col-md-3 pb-2 px-2 px-md-4" }
const _hoisted_19 = { class: "block blue" }
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "row pb-3" }
const _hoisted_23 = { class: "col-md-3 pb-2 px-2 px-md-4" }
const _hoisted_24 = { class: "block pb-0" }
const _hoisted_25 = { class: "title two-line-md-only" }
const _hoisted_26 = { class: "col-md-3 pb-2 px-2 px-md-4" }
const _hoisted_27 = { class: "block pb-0" }
const _hoisted_28 = { class: "title two-line-md-only" }
const _hoisted_29 = { class: "row pb-3" }
const _hoisted_30 = {
  class: "text-white mb-2 px-2",
  style: {"font-weight":"bold"}
}
const _hoisted_31 = { class: "table table-borderless mb-0 p-3" }
const _hoisted_32 = { class: "px-2" }
const _hoisted_33 = { class: "px-2" }
const _hoisted_34 = { class: "px-2" }
const _hoisted_35 = { class: "px-2" }
const _hoisted_36 = { class: "px-2" }
const _hoisted_37 = { class: "px-2" }
const _hoisted_38 = { class: "row mb-3" }
const _hoisted_39 = { class: "px-2 px-md-4" }
const _hoisted_40 = { class: "block flex-row justify-content-between px-4 pt-4 pb-0" }
const _hoisted_41 = { class: "title two-line-md-only" }
const _hoisted_42 = {
  class: "filter-block col-6 col-md-3 col-lg-2",
  style: {"padding-inline-end":"0","margin-inline-end":"0"}
}
const _hoisted_43 = { class: "col-md-6 pb-2 px-2 px-md-4" }
const _hoisted_44 = {
  class: "block px-3",
  style: {"box-shadow":"none"}
}
const _hoisted_45 = { class: "row px-2 px-md-4" }
const _hoisted_46 = { class: "block px-3 pt-3 pb-1" }
const _hoisted_47 = {
  class: "table table-borderless mb-0 table-index-users-chats",
  style: {"color":"black"}
}
const _hoisted_48 = {
  width: "50%",
  style: {"font-size":"18px","font-weight":"500","padding-bottom":"6px !important"}
}
const _hoisted_49 = {
  width: "50%",
  style: {"font-size":"18px","font-weight":"500","padding-bottom":"6px !important"}
}
const _hoisted_50 = { width: "50%" }
const _hoisted_51 = { width: "50%" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_PieBlock = _resolveComponent("PieBlock")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_TimelineBlock = _resolveComponent("TimelineBlock")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('pageTitle.index-statistics')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-green",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.shortcut('today')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.today')), 1),
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-lred",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.shortcut('yesterday')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.yesterday')), 1),
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-orange",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.shortcut('week')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.week')), 1),
        _createVNode("button", {
          type: "button",
          class: "circle-btn btn-orange",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.shortcut('month')))
        }, _toDisplayString(_ctx.$t('report.dashboard.shortcuts.month')), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('index-statistics.filter.filter-by-dates')), 1),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", null, [
              _createVNode(_component_Calendar, {
                style: {"max-width":"164px"},
                modelValue: _ctx.dateRange.fromDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateRange.fromDate = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                maxDate: _ctx.dateRange.toDate,
                class: "calendar-filter"
              }, null, 8, ["modelValue", "maxDate"]),
              _createVNode(_component_Calendar, {
                style: {"max-width":"164px"},
                modelValue: _ctx.dateRange.toDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateRange.toDate = $event)),
                selectionMode: "single",
                dateFormat: "dd/mm/yy",
                minDate: _ctx.dateRange.fromDate,
                class: "calendar-filter mx-md-3"
              }, null, 8, ["modelValue", "minDate"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.loadData && _ctx.loadData(...args)))
                }, [
                  _hoisted_10
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode("span", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args))),
                  class: "fs-18"
                }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('index-statistics.dash-boards.quotes')), 1),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.numberOfQuotes), 1)
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('index-statistics.dash-boards.chats')), 1),
            _createVNode("div", _hoisted_21, _toDisplayString(_ctx.numberOfChats), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_22, [
        _createVNode("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('index-statistics.pie-number-per-product.quotes')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.productPieData.productNumberOfQuotes,
              "show-title-legend": false,
              "title-legen-text": _ctx.$t('index-statistics.pie-number-per-product.quotes'),
              pallete: _ctx.colorScheme,
              "is-gradient": true
            }, null, 8, ["data", "title-legen-text", "pallete"])
          ])
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('index-statistics.pie-number-per-product.chats')), 1),
            _createVNode(_component_PieBlock, {
              data: _ctx.productPieData.productNumberOfChats,
              "show-title-legend": false,
              "title-legen-text": _ctx.$t('index-statistics.pie-number-per-product.chats'),
              pallete: _ctx.colorScheme,
              "is-gradient": true
            }, null, 8, ["data", "title-legen-text", "pallete"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_29, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.productsStatistics, (row, index) => {
          return (_openBlock(), _createBlock("div", {
            key: row.id,
            class: "col-md-3 px-2 px-md-4 mb-3"
          }, [
            _createVNode("div", {
              class: "p-3 w-100",
              style: { background: _ctx.createBackgroundString(index % _ctx.colorScheme.length) }
            }, [
              _createVNode("h5", _hoisted_30, _toDisplayString(row.name), 1),
              _createVNode("table", _hoisted_31, [
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_32, _toDisplayString(_ctx.$t('index-statistics.product.results-page-displays')), 1),
                  _createVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('index-statistics.product.product-page-visits')), 1),
                  _createVNode("th", _hoisted_34, _toDisplayString(_ctx.$t('index-statistics.product.show-contacts-clicks')), 1)
                ]),
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_35, _toDisplayString(row.resultPageDisplays), 1),
                  _createVNode("td", _hoisted_36, _toDisplayString(row.productPageVisits), 1),
                  _createVNode("td", _hoisted_37, _toDisplayString(row.showContactsClicks), 1)
                ])
              ])
            ], 4)
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_38, [
        _createVNode("div", _hoisted_39, [
          _createVNode("div", _hoisted_40, [
            _createVNode("div", _hoisted_41, _toDisplayString(_ctx.$t('index-statistics.timeline')), 1),
            _createVNode("div", _hoisted_42, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.productName,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.productName = $event)),
                label: "name",
                "track-by": "name",
                multiple: false,
                options: _ctx.productsStatistics.map(x => x.name),
                "close-on-select": false,
                "show-labels": false,
                searchable: false,
                placeholder: ""
              }, null, 8, ["modelValue", "options"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _createVNode(_component_TimelineBlock, {
              data: _ctx.timeline.data,
              showLegend: true
            }, null, 8, ["data"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_45, [
        _createVNode("div", _hoisted_46, [
          _createVNode("table", _hoisted_47, [
            _createVNode("tr", null, [
              _createVNode("th", _hoisted_48, _toDisplayString(_ctx.$t('index-statistics.list-of-agents')), 1),
              _createVNode("th", _hoisted_49, _toDisplayString(_ctx.$t('index-statistics.list-of-agencies')), 1)
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.indexUsersChats, (row, index) => {
              return (_openBlock(), _createBlock("tr", {
                key: index,
                class: ["index-users-chats", { 'index-users-chats-border': index > 0 }]
              }, [
                _createVNode("td", _hoisted_50, _toDisplayString(row.name), 1),
                _createVNode("td", _hoisted_51, _toDisplayString(row.agencyName), 1)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}